<HistoryUploadSearch headerTextOther="Other History Upload" detailsType="Other" AddURL="/Other/OtherHistoryUploadDetail">